module.exports = __webpack_public_path__ + "img/main-map-2.5c377f70.jpg";